import React  from "react";
import { Box, Typography } from "@material-ui/core";
import { DPTable, DPEmptyTable, DPComponentLoader } from "Components/DP";
import { OperatingManagersTableRow } from "./OperatingManagersTableRow/OperatingManagersTableRow";
import { DPOperatingManager } from "Shared/types/OperatingManager";
import { useOperatingManagersHook } from "../services/useOperatingManagersHook";
import useStyles from "./styles";
import { usePartnerConfig } from "Hooks/usePartnerConfig";

const HEADERS = [
  "Name",
  "Access Level",
  "Location(s)",
  "Budget",
  "Secondary Approver",
  "Action",
];

export interface OperatingManagersTableProps {
  onEdit: (manager: DPOperatingManager) => void;
}

export const OperatingManagersTable = (props: OperatingManagersTableProps) => {
  const classes = useStyles();
  const { operatingManagers, loading, page, rowsPerPage, onChangePage } = useOperatingManagersHook();
  const { permissions } = usePartnerConfig();
  const canEditManagers = permissions.canCreateRewardBudgets;
  const headers = canEditManagers
    ? HEADERS
    : HEADERS.filter(header => header !== "Action");

  return (
    <Box marginTop={4}>
      <Typography variant="h3" className={classes.tableTitle}>
        Operating Manager List
      </Typography>
      <DPTable
        count={operatingManagers?.totalCount}
        headers={headers}
        loading={loading}
        onChangePage={onChangePage}
        page={page}
        rowsPerPage={rowsPerPage}
        className={classes.table}
      >
        <DPComponentLoader
          isLoading={loading}
          kind="table"
          awaitComponent={
            <>
              {
                operatingManagers?.totalCount
                  ? operatingManagers.items.map(operatingManager => (
                    <OperatingManagersTableRow
                      key={operatingManager.id}
                      manager={operatingManager}
                      onEdit={props.onEdit}
                      canEditManagers={canEditManagers}
                    />
                  ))
                  : <DPEmptyTable message="Operating Managers will appear here." />
              }
            </>
          }
        />
      </DPTable>
    </Box>
  );
};
